// services/countryService.js
import { apiRequest } from './api';

export const countryService = {
    getCountries: async () => {
        const res = await apiRequest.get('/countries-dialcodes'); // Or '/countries' if that's your endpoint
        return res.data.data;
    },
    // Existing function: Get cities by country_id
    getCities: async (countryId) => {
        const res = await apiRequest.get('/cities', { params: { country_id: countryId } });
        return res.data.data;
    },
    // NEW function: Get cities by country_code (e.g., 'PK', 'US')
    getCitiesByCountryCode: async (countryCode) => {
        // Call the NEW backend endpoint you created
        const res = await apiRequest.get('/cities-by-code', { // Use the new endpoint path
            params: { country_code: countryCode }
        });
        return res.data.data;
    }
};